import React from "react";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { TimeslotColumns } from "../../../types";

import type { JSX } from "react";

export const TIMESLOT_RULES_COLUMN_CLASSNAMES = {
  base: "flex items-center justify-center p-[0.78125rem] bg-card flex-1",
  get [TimeslotColumns.Rank](): string {
    return `${this.base} min-w-[5rem] grow-0`;
  },
  get [TimeslotColumns.Mode](): string {
    return `${this.base} min-w-[5rem] grow-0`;
  },
  get [TimeslotColumns.Source](): string {
    return `${this.base} min-w-[15rem]`;
  },
  get [TimeslotColumns.Count](): string {
    return `${this.base} min-w-[5.625rem] grow-0`;
  },
  get [TimeslotColumns.StartIndex](): string {
    return `${this.base} min-w-[15rem]`;
  },
  get [TimeslotColumns.Increment](): string {
    return `${this.base} min-w-[5.625rem] grow-0`;
  },
  get [TimeslotColumns.Ads](): string {
    return `${this.base} min-w-[15rem]`;
  },
  get [TimeslotColumns.Delete](): string {
    return `${this.base} min-w-[5rem] grow-0`;
  },
};

function TimeslotRuleHeader(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const indexColumnClassName = classNames(
    TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.Rank],
    "rounded-tl-lg",
  );

  const deleteColumnClassName = classNames(
    TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.Delete],
    "rounded-tr-lg",
  );

  return (
    <div className="border-t-border sticky top-0 z-10 flex min-h-[4.375rem] divide-x border-x-2 border-t-2 border-x-transparent font-medium whitespace-nowrap drop-shadow-sm">
      <div className={indexColumnClassName}>{t("index")}</div>
      <div className={TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.Mode]}>
        {t("mode")}
      </div>
      <div className={TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.Source]}>
        {t("sourcePlaylist")}
      </div>
      <div className={TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.Count]}>
        {t("number")}
      </div>
      <div
        className={TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.StartIndex]}
      >
        {t("startingIndex")}
      </div>
      <div
        className={TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.Increment]}
      >
        {t("increment")}
      </div>
      <div className={TIMESLOT_RULES_COLUMN_CLASSNAMES[TimeslotColumns.Ads]}>
        {t("adBreakInsert")}
      </div>
      <div className={deleteColumnClassName} />
    </div>
  );
}

export default TimeslotRuleHeader;
